import { Timeline } from "antd";

const TimeLineEvent = (event) => {
  return (
    <>
      {event.mensaje && (
        <div className="event-timeline-text">
          {event.mensaje.split('\n').map(e => <p>{e}</p>)}
        </div>
      )}

      {event.tipo && (
        <p>
          <b>Tipo:</b> {event.tipo}
        </p>
      )}
      {event.fecha_evento && (
        <p className="event-timeline-date">
          <em>
            {new Date(event.fecha_evento).toLocaleDateString()} a las {new Date(event.fecha_evento).toLocaleTimeString()}
          </em>
        </p>
      )}
    </>
  );
};
export function TimeLine({ events }) {
  const TimeLineEvents = events.map((event) => {
    return {
      color: "gray",
      children: <TimeLineEvent {...event.evento} />,
    };
  });
  return <Timeline items={[...TimeLineEvents]} />;
}
